import { render, staticRenderFns } from "./QuangCaoList.vue?vue&type=template&id=b0b5331a"
import script from "./QuangCaoList.vue?vue&type=script&lang=js"
export * from "./QuangCaoList.vue?vue&type=script&lang=js"
import style0 from "./QuangCaoList.vue?vue&type=style&index=0&id=b0b5331a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports